import { useCallback, useEffect, useState } from 'react'
import { getOrdinanceData } from '../services/personService'
import useNotifications from './useNotifications'

export default function usePersonOrdinances(personId) {
  const { showServerNotifications, warn } = useNotifications()
  const [ordinanceData, setOrdinanceData] = useState()
  const [refetchSwitch, setRefetchSwitch] = useState(true)

  useEffect(() => {
    const fetchOrdinanceData = async () => {
      try {
        const response = await getOrdinanceData(personId)
        if (response && response.status === 200) {
          setOrdinanceData(response.data)
        }
      } catch (err) {
        showServerNotifications(err?.response?.data?.notifications, 'error')
      }
    }
    if (personId) {
      fetchOrdinanceData()
    }
  }, [personId, refetchSwitch, showServerNotifications, warn])

  const refetchOrdinances = useCallback(() => setRefetchSwitch(!refetchSwitch), [refetchSwitch])

  return {
    ordinanceData,
    refetchOrdinances,
    setOrdinanceData,
  }
}
